import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postChangeLetter = (params) => {
    return axios.post(`${backendHost}/api/admin/cashiers/change-letter`, params);
};

export {
    postChangeLetter
}